export default "__VITE_ASSET__C$37Ig3o__"